if (!customElements.get("bundle-products")) {
  customElements.define(
    "bundle-products",
    class BundleProducts extends HTMLElement {
      constructor() {
        super();
        if (!document.querySelector("bundle-products")) return;
        this.selectedProducts = [];
        this.discount_type = this.querySelector("#discount_type").value;
        this.discount_value = Number(
          this.querySelector("#discount_value").value
        );

        this.regular_price = Number(
          this.querySelector("#bundle_regular_price").value
        );
        this.sale_price = Number(
          this.querySelector("#bundle_sale_price").value
        );

        this.regular_price_wrapper = this.querySelector(
          "#bundle_regular_price_wrapper"
        );
        this.sale_price_wrapper = this.querySelector(
          "#bundle_sale_price_wrapper"
        );
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.add_all_items_button = this.querySelector("button.add_all_items");
        this.add_all_items_button.addEventListener("click", (_) =>
          this.addAllItems()
        );
        this.registerClickEvents();
      }

      addAllItems() {
        //bundle_products
        this.querySelectorAll(
          ".bundle-products li input[id*='bundle-product']:checked"
        ).forEach((bundle_product) => {
          const variant_id = bundle_product.value;

          this.selectedProducts.push({
            id: variant_id,
            quantity: 1,
          });
        });

        //currentProduct
        const currentProductVariantIdInput = document.querySelector(
          "product-form form input[name='id']"
        );
        if (currentProductVariantIdInput !== null) {
          const currentProductVariantId = currentProductVariantIdInput.value;

          const newProduct = {
            id: currentProductVariantId,
            quantity: 1,
          };

          this.selectedProducts.push(newProduct);
        } else {
          console.error("Could not find product variant ID input");
        }
        this.addCart(true);
      }

      async addCart(openDrawerMenu = true) {
        const config = fetchConfig();

        config.headers["Content-Type"];

        const formBody = {
          items: [],
        };

        if (this.selectedProducts.length <= 0) return;

        this.selectedProducts.forEach((product) => {
          formBody.items.push({
            id: Number(product.id),
            quantity: 1,
          });
        });

        let sections_to_render = this.cart
          .getSectionsToRender()
          .map((section) => section.id);
        if (this.cart) {
          formBody.sections = sections_to_render;
          formBody.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = JSON.stringify(formBody);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            return response.json();
          })
          .then(async (response) => {
            if (response.status) {
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" });
            this.error = false;

            if (!response.sections) {
              response.sections = await fetch(
                `/?sections=${sections_to_render}`
              ).then((t) => t.json());
            }
            await this.cart.renderContents(response, openDrawerMenu);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.add_all_items_button.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) {
              this.selectedProducts = [];
              this.add_all_items_button.removeAttribute("aria-disabled");
            }
          });
      }
      updateTotalPrice(price, oldPrice, isPlus) {
        if (isPlus) {
          this.regular_price += Number(oldPrice);
          this.sale_price += Number(price);
        } else {
          this.regular_price -= Number(oldPrice);
          this.sale_price -= Number(price);
        }

        this.updatePrices();
      }

      updatePrices() {
        this.regular_price_wrapper.innerText = Shopify.formatMoney(
          this.regular_price
        );
        this.sale_price_wrapper.innerText = Shopify.formatMoney(
          this.sale_price
        );

        const will_inactive_items = document.querySelectorAll(
          ".hide-on-inactive-bundle"
        );
        if (will_inactive_items.length == 0) return;

        will_inactive_items.forEach((elem) =>
          elem.classList.toggle(
            "opacity-0",
            this.sale_price >= this.regular_price
          )
        );
      }

      onVariantChanged() {
        const activeBundles = document.querySelectorAll(
          "bundle-products li input:checked"
        );
        if (activeBundles.length == 0) return;

        const calculateSalePrice = function (acc, val) {
          const { price } = val.dataset;
          if (!price) return 0;
          return acc + Number(price);
        };

        const calculateRegularPrice = function (acc, val) {
          const { oldPrice } = val.dataset;
          if (!oldPrice) return 0;
          return acc + Number(oldPrice);
        };

        const totalSalePrice = Array.from(activeBundles).reduce(
          calculateSalePrice,
          0
        );
        const totalRegularPrice = Array.from(activeBundles).reduce(
          calculateRegularPrice,
          0
        );

        if (!window.currentVariant) {
          console.log("Current variant not defined");
          return;
        }

        this.sale_price = totalSalePrice + Number(window.currentVariant.price);
        this.regular_price =
          totalRegularPrice + Number(window.currentVariant.price);

        this.updatePrices();
      }

      registerClickEvents() {
        this.querySelectorAll(
          "bundle-products li select[name='variant_id']"
        ).forEach((variant_selector) => {
          if (!variant_selector) return;
          variant_selector.addEventListener("change", (e) => {
            e.preventDefault();

            const target_variant_input_selector =
              e.target.dataset.depended_input;
            const target_variant_input = document.getElementById(
              target_variant_input_selector
            );

            if (
              !target_variant_input ||
              !(target_variant_input instanceof HTMLInputElement)
            )
              return;
            target_variant_input.value = e.target.value;
            const selected_option = e.target.selectedOptions[0];
            if (!selected_option) return;
            const { price, oldPrice } = selected_option.dataset;
            const product_info_wrapper = e.target.parentNode;
            target_variant_input.setAttribute("data-price", price);
            target_variant_input.setAttribute("data-old-price", oldPrice);

            const old_price_wrapper = product_info_wrapper.querySelector(
              ".text-compare-price"
            );
            if (old_price_wrapper)
              old_price_wrapper.innerText = Shopify.formatMoney(oldPrice);
            const price_wrapper =
              product_info_wrapper.querySelector(".text-price");
            if (price_wrapper)
              price_wrapper.innerText = Shopify.formatMoney(price);

            this.onVariantChanged();
          });
        });

        this.querySelectorAll("bundle-products li input").forEach(
          (bundle_input) => {
            if (!bundle_input) return;
            bundle_input.addEventListener("input", (e) => {
              const { price, oldPrice } = e.target.dataset;
              this.updateTotalPrice(price, oldPrice, e.target.checked);
            });
          }
        );
      }
    }
  );
}
window.bundleVariantChangeEvent = () => {
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    document.querySelector(".bundle_prices_wrapper").innerHTML =
      data.html.querySelector(".bundle_prices_wrapper").innerHTML;
  });
};
document.addEventListener("DOMContentLoaded", () => {
  window.bundleVariantChangeEvent();
});
